import { useContext } from "react"
import classNames from "classnames"

import { Icon } from "web/components"
import { pluralize, removeUnderscore, underscore } from "web/services/inflector"
import { DataTableContext } from "./DataTable"
import { GroupDisplayValue } from "./helpers"

export default function RowGroupTitle({
  groupKey,
  groupSize,
  groupValues,
  expanded,
  onGroupCollapseToggle,
}) {
  const {
    groupColumnLabel,
    secondGroupColumnLabel,
    itemLabel,
    isCompact,
    canCollapseGroups,
    columnCount,
    hasFrozenColumns,
  } = useContext(DataTableContext)

  const summaryText = `${groupSize} ${removeUnderscore(
    groupSize === 1 ? itemLabel : pluralize(itemLabel)
  )}`

  const firstGroupValue = groupValues[0]
  const secondGroupValue = groupValues[1]
  const hasSecondGroupValue = !!secondGroupValue

  const testId = `datatable-group-title-row-${
    !firstGroupValue
      ? groupColumnLabel
      : underscore("" + firstGroupValue.value.value)
  }`

  const containerClasses = classNames(
    "flex items-center border-b border-gray-50 bg-primary-10 font-bold",
    {
      "h-9": isCompact,
      "sticky left-0": hasFrozenColumns,
      "overflow-hidden": !hasFrozenColumns,
    }
  )

  return (
    <div
      data-testid={testId}
      className={containerClasses}
      style={{ gridColumn: `1 / span ${columnCount}` }}
    >
      <div className="sticky left-0 flex items-center space-x-2 overflow-visible p-2">
        {canCollapseGroups && (
          <div
            className="cursor-pointer rounded-md p-1 hover:bg-primary-9 focus:outline-none"
            onClick={() => onGroupCollapseToggle(groupKey)}
          >
            <Icon name={expanded ? "chevron-down" : "chevron-right"} outline />
          </div>
        )}
        <GroupDisplayValue
          value={firstGroupValue}
          columnLabel={groupColumnLabel}
        />
        {hasSecondGroupValue && (
          <>
            <span>/</span>
            <GroupDisplayValue
              value={secondGroupValue}
              columnLabel={secondGroupColumnLabel}
            />
          </>
        )}
        <span className="ml-1 font-normal italic">{summaryText}</span>
      </div>
    </div>
  )
}
